import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'styles/index.css';
import { App } from './App.tsx';
import i18n from './locale/i18n.ts';
import { ServiceUnavailablePage } from './pages/ServiceUnavailablePage.tsx';

import './dayjs-config.ts';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_VERCEL_ENV,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
      }),
      Sentry.browserTracingIntegration(),
    ],
  });
}

const isServiceUnavailable = import.meta.env.VITE_API_IS_SERVICE_UNAVAILABLE === 'true';

window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      {isServiceUnavailable ? <ServiceUnavailablePage /> : <App />}
    </I18nextProvider>
  </StrictMode>,
);
